import { getFoodieProgress, clearAllProgress, syncToFirebase } from './foodieProgress.js';
import { getDatabase, ref, get as fbGet } from "firebase/database";
import { initializeApp } from "firebase/app";
import { foodieConfig } from '/js/lib/firebase-config.js';
import { getOrCreateFoodieId } from './foodieId.js';
// import { renderBadgesGallery } from './badges.js'; // DISABLED: Focusing on quests & must-try
import { openEateryModal } from './quests.js';

const DRUPAL_API_BASE = window.location.hostname.includes('localhost')
  ? 'http://localhost:8888'
  : 'https://ggcity.org';

// Initialize with foodie database config
const foodieApp = initializeApp(foodieConfig, 'foodie-db-profile');
const db = getDatabase(foodieApp);

// Increment the share count when user clicks Share button
async function incrementShareCount(foodieId) {
  try {
    const { runTransaction } = await import('firebase/database');
    const shareCountRef = ref(db, `foodiesProgress/${foodieId}/mustTryShareCount`);
    
    await runTransaction(shareCountRef, (currentValue) => {
      return (currentValue || 0) + 1;
    });
    
    console.info('Must-try list share counted');
  } catch (err) {
    console.warn('Failed to increment share count:', err);
  }
}

async function loadProfile() {
  const profileSection = document.querySelector('gg-app[fogg] #profile');
  if (!profileSection) {
    console.warn('Profile section not found. Skipping load.');
    return;
  }

  // Grab all UI elements
  const visitedEl     = profileSection.querySelector('#stat-visited');
  const mustTryEl     = profileSection.querySelector('#stat-musttry');
  const questsEl      = profileSection.querySelector('#stat-quests');
  // const badgesEl      = profileSection.querySelector('#stat-badges'); // DISABLED: Focusing on quests & must-try
  const lastSyncEl    = profileSection.querySelector('#last-sync');
  const completedQuestsEl = profileSection.querySelector('#completed-quests-list');
  const monsterImg = profileSection.querySelector('#foodie-monster');

  // Load foodie random foodie monster (Introduce idea in this iteration, expand later if there's interest)
  const monsterId = Math.floor(Math.random() * 6) + 1; // random number from 1 to 6

  if (monsterImg) {
    monsterImg.src = `/images/monsters/${monsterId}.png`;
  }

  // Load foodie progress (merged local+remote)
  const progress = await getFoodieProgress();
  const mustTry = progress.mustTry || [];
  const visited = progress.visited || [];
  const quests  = progress.quests  || [];
  // const badges  = progress.badges  || []; // DISABLED: Focusing on quests & must-try

  // ✅ Update the summary stats
  visitedEl.textContent  = visited.length;
  mustTryEl.textContent  = mustTry.length;
  if (questsEl) questsEl.textContent = quests.length; // Only update if element exists
  // badgesEl.textContent   = badges.length; // DISABLED: Focusing on quests & must-try

  // calculate score
  const visitedPoints = visited.length * 100;
  const mustTryPoints = mustTry.length * 100;
  // const badgePoints   = badges.length * 500; // DISABLED: Focusing on quests & must-try
  const questPoints   = quests.length * 1000;

  const totalScore = visitedPoints + mustTryPoints + questPoints; // + badgePoints

  // Update the DOM
  document.querySelector('#score').textContent = totalScore.toLocaleString(); // Optional formatting

  // ✅ Must Try list (limit 10, names)
  renderMustTryList();

  // ✅ Visited list
  renderVisitedList();

  // Render all quests (completed and locked)
  try {
    // Try cache first for instant load
    let allQuests;
    const cachedQuests = localStorage.getItem('fogg_quest_metadata');
    
    if (cachedQuests) {
      allQuests = JSON.parse(cachedQuests);
      console.log('⚡ Using cached quest data in profile');
    } else {
      const response = await fetch(`${DRUPAL_API_BASE}/api/fogg/foodie-quests`, {
        mode: 'cors',
        credentials: 'omit'
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      allQuests = await response.json();
      
      // Cache for future use
      try {
        localStorage.setItem('fogg_quest_metadata', JSON.stringify(allQuests));
      } catch (e) {
        console.warn('Failed to cache quest metadata', e);
      }
    }
    const completedSet = new Set(quests.map(q => q.toString()));
    
    // Show message if no quests completed
    if (quests.length === 0) {
      completedQuestsEl.insertAdjacentHTML('beforebegin', `<p class="no-quests">No quests completed yet!</p>`);
    }
    
    // Render all quests
    allQuests.forEach(questData => {
      const isCompleted = completedSet.has(questData.id.toString());
      const wrapper = document.createElement('div');
      wrapper.className = `quest-item ${isCompleted ? '' : 'locked'}`;
      wrapper.style.cursor = 'pointer';
      wrapper.dataset.questId = questData.id;

      wrapper.innerHTML = `
        <img src="/images/quests/${questData.machine_name}-thumb.png" alt="${questData.name}" />
        <span class="quest-label ${isCompleted ? '' : 'locked-label'}">${questData.name}</span>
      `;

      // Add click handler to navigate to quests page
      wrapper.addEventListener('click', () => {
        const basePath = window.location.hostname.includes('fogg.app') ? '/' : '/fogg/';
        window.location.href = `${basePath}quests?quest=${questData.id}`;
      });

      completedQuestsEl.appendChild(wrapper);
    });
  } catch (err) {
    console.error('Error fetching quest names:', err);
    // Fallback: just show completed quests
    if (quests.length > 0) {
      quests.forEach(qId => {
        const wrapper = document.createElement('div');
        wrapper.className = 'quest-item';
        wrapper.innerHTML = `
          <img src="/images/quests/default-thumb.png" alt="Quest #${qId}" />
          <span class="quest-label">Quest #${qId}</span>
        `;
        completedQuestsEl.appendChild(wrapper);
      });
    } else {
      completedQuestsEl.insertAdjacentHTML('afterbegin', `<p class="no-quests">No quests completed yet!</p>`);
    }
  }

  // renderBadgesGallery() // DISABLED: Focusing on quests & must-try

  // ✅ Last Sync
  const foodieId = await getOrCreateFoodieId();
  const fbSnap = await fbGet(ref(db, `foodiesProgress/${foodieId}/updatedAt`));
  if (fbSnap.exists()) {
    lastSyncEl.textContent = new Date(fbSnap.val()).toLocaleString();
  } else {
    lastSyncEl.textContent = 'Never';
  }
}

// Attach behavior once DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const profileSection = document.querySelector('gg-app[fogg] #profile');
  if (!profileSection) return;

  loadProfile().then(() => {
    // After profile loads, check for hash and scroll to it
    if (window.location.hash) {
      // Use requestAnimationFrame + setTimeout for better cross-browser support
      requestAnimationFrame(() => {
        setTimeout(() => {
          const targetId = window.location.hash.substring(1);
          const targetElement = document.getElementById(targetId);
          if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 500);
      });
    }
  });
  
  setupLightbox();
  setupStatScrolling();

  const clearBtn = profileSection.querySelector('#clear-progress-btn');
  if (clearBtn) {
    clearBtn.addEventListener('click', async () => {
      if (!confirm('Are you sure you want to clear ALL your foodie progress?')) return;

      await clearAllProgress(); // local reset

      const foodieId = await getOrCreateFoodieId(); // also reset remote
      await syncToFirebase(foodieId);

      alert('Your foodie progress has been reset.');
      loadProfile(); // refresh UI
    });
  }

});

async function renderMustTryList() {
  const galleryEl = document.getElementById('must-try-gallery');
  
  // Clear existing items (but keep grid-sizer)
  const existingItems = galleryEl.querySelectorAll('.grid-item');
  existingItems.forEach(item => item.remove());

  const { mustTry = [] } = await getFoodieProgress();

  if (mustTry.length === 0) {
    // Hide share button when list is empty
    document.getElementById('action-area').classList.add('d-none');
    
    // Invite the user to explore if they haven't added any yet
    const emptyMsg = document.createElement('div');
    emptyMsg.className = 'no-must-try';
    emptyMsg.innerHTML = `
      <p>Your Must Try list is your personal foodie guide — the places you'd recommend to anyone. Start adding your top picks!</p>
      <button id="invite-explore-btn" class="explore-btn gradient-border">
        <img src="/images/explore.png" alt="" class="btn-icon" />
        Explore!
      </button>
    `;
    galleryEl.appendChild(emptyMsg);
    
    document.getElementById('invite-explore-btn').addEventListener('click', () => {
      window.location.href = '/explore';
    });
    return;
  }

  // Show share button only when there are items
  document.getElementById('action-area').classList.remove('d-none');

  // Create fragment for batch DOM insertion
  const fragment = document.createDocumentFragment();
  const newItems = [];

  // Load restaurant data for each must-try item
  for (const placeId of mustTry) {
    const cacheKey = `restaurant_${placeId}`;
    let restaurantData = null;

    // Try cache first
    try {
      const cached = localStorage.getItem(cacheKey);
      if (cached) {
        const { data, timestamp } = JSON.parse(cached);
        if (Date.now() - timestamp < 86400000) {
          restaurantData = data;
          console.log(`⚡ Loaded restaurant ${placeId} from cache`);
        }
      }
    } catch (e) {
      console.warn('Failed to parse cached restaurant data', e);
    }

    // Fetch if not cached
    if (!restaurantData) {
      try {
        const res = await fetch(`${DRUPAL_API_BASE}/api/fogg/restaurant/${placeId}`);
        restaurantData = await res.json();
        
        // Cache for future use
        try {
          localStorage.setItem(cacheKey, JSON.stringify({
            data: restaurantData,
            timestamp: Date.now()
          }));
        } catch (e) {
          console.warn('Failed to cache restaurant data', e);
        }
      } catch (err) {
        console.error(`Failed to fetch restaurant ${placeId}:`, err);
        continue;
      }
    }

    // Create masonry grid item (match explore.js structure exactly)
    const gridItem = document.createElement('div');
    gridItem.className = 'grid-item';
    gridItem.dataset.id = placeId;
    gridItem.style.cursor = 'pointer';

    const restaurant = document.createElement('div');
    restaurant.className = 'restaurant';

    const img = new Image();
    img.src = restaurantData.hero_image || '/images/placeholder.png';
    img.alt = restaurantData.title || 'Restaurant';
    img.className = 'explore-thumbnail';
    img.loading = 'lazy';
    img.decoding = 'async';

    const title = document.createElement('div');
    title.className = 'explore-title';
    title.textContent = restaurantData.title || `Place #${placeId}`;

    restaurant.appendChild(img);
    restaurant.appendChild(title);
    gridItem.appendChild(restaurant);
    fragment.appendChild(gridItem);
    newItems.push(gridItem);
  }

  // Append all items to gallery
  galleryEl.appendChild(fragment);

  // Add full-width class if only one item
  if (mustTry.length === 1) {
    galleryEl.classList.add('single-item');
  } else {
    galleryEl.classList.remove('single-item');
  }

  // Initialize Masonry after images load
  imagesLoaded(newItems, () => {
    if (!galleryEl.masonryInstance) {
      galleryEl.masonryInstance = new Masonry(galleryEl, {
        itemSelector: '.grid-item',
        columnWidth: '.grid-sizer',
        percentPosition: true,
      });
      console.log('📐 Masonry initialized for must-try gallery');
    } else {
      galleryEl.masonryInstance.appended(newItems);
      galleryEl.masonryInstance.layout();
    }
    
    // Force a slight delayed layout recalculation to fix stacking glitches
    setTimeout(() => {
      if (galleryEl.masonryInstance) {
        galleryEl.masonryInstance.layout();
        console.log('🔁 Masonry re-layout triggered');
      }
    }, 100);
  });
}

async function renderVisitedList() {
  const visitedListEl = document.getElementById('visited-list');
  visitedListEl.innerHTML = '';

  const { visited = [] } = await getFoodieProgress();

  if (visited.length === 0) {
    visitedListEl.innerHTML = `
      <li class="no-visited">
        No visited eateries yet. Start exploring and mark the places you've been!
      </li>
    `;
    return;
  }

  // Show visited eateries
  for (const placeId of visited) {
    const li = document.createElement('li');
    li.dataset.placeId = placeId;
    li.classList.add('place-title-btn');
    
    // Try cache first
    const cacheKey = `restaurant_${placeId}`;
    const cached = localStorage.getItem(cacheKey);
    
    if (cached) {
      try {
        const { data, timestamp } = JSON.parse(cached);
        // Use cache if less than 24 hours old
        if (Date.now() - timestamp < 86400000) {
          li.textContent = data.title || `Place #${placeId}`;
          visitedListEl.appendChild(li);
          console.log(`⚡ Loaded restaurant ${placeId} from cache`);
          continue;
        }
      } catch (e) {
        console.warn('Failed to parse cached restaurant data', e);
      }
    }
    
    // No cache or expired, fetch from API
    li.textContent = `Loading place ${placeId}…`;
    visitedListEl.appendChild(li);

    fetch(`${DRUPAL_API_BASE}/api/fogg/restaurant/${placeId}`)
      .then(res => res.json())
      .then(data => {
        li.textContent = data.title || `Place #${placeId}`;
        
        // Cache for future use
        try {
          localStorage.setItem(cacheKey, JSON.stringify({
            data,
            timestamp: Date.now()
          }));
        } catch (e) {
          console.warn('Failed to cache restaurant data', e);
        }
      })
      .catch(() => {
        li.textContent = `Place #${placeId}`;
      });
  }
}

document.getElementById('share-must-try-link').addEventListener('click', async () => {
  try {
    // Get foodie ID
    const foodieId = await getOrCreateFoodieId();
    
    // Increment share counter
    await incrementShareCount(foodieId);
    
    // Extract last 6 characters
    const shortId = foodieId.slice(-6);
    
    // Generate shareable link - check if we're on fogg.app or app.ggcity.org/fogg
    const basePath = window.location.hostname.includes('fogg.app') ? '/' : '/fogg/';
    const shareLink = `${window.location.origin}${basePath}must-try.html?id=${shortId}`;
    
    // Try clipboard API first (most reliable for URL-only copying)
    if (navigator.clipboard && navigator.clipboard.writeText) {
      try {
        await navigator.clipboard.writeText(shareLink);
        showToast('Link copied to clipboard!', 'success');
        return;
      } catch (clipboardErr) {
        console.log('Clipboard API failed, trying Web Share API');
      }
    }
    
    // Try Web Share API (share just the URL without text to avoid text+url combo)
    if (navigator.share) {
      try {
        await navigator.share({
          url: shareLink
        });
        showToast('Link shared!', 'success');
        return;
      } catch (shareErr) {
        // User cancelled or share failed, continue to fallback
        if (shareErr.name === 'AbortError') {
          return; // User cancelled, don't show error
        }
      }
    }
    
    // Final fallback - show the link for manual copying
    const result = prompt('Copy this link to share your list:', shareLink);
    if (result !== null) {
      showToast('Link ready to share!', 'success');
    }
    
  } catch (err) {
    console.error('Failed to share link:', err);
    showToast('Failed to share link. Please try again.', 'error');
  }
});

// Toast notification function
function showToast(message, type = 'info') {
  const toast = document.createElement('div');
  toast.className = `toast toast-${type}`;
  toast.textContent = message;
  document.body.appendChild(toast);
  
  // Show toast
  requestAnimationFrame(() => toast.classList.add('show'));
  
  // Remove after 3 seconds
  setTimeout(() => {
    toast.classList.remove('show');
    setTimeout(() => toast.remove(), 300);
  }, 3000);
}

// --- Handle clicks ---
document.addEventListener('click', async (e) => {
  // Handle must-try gallery clicks (click on grid-item container)
  const gridItem = e.target.closest('#must-try-gallery .grid-item');
  if (gridItem?.dataset?.id) {
    openEateryModal(gridItem.dataset.id);
    return;
  }

  // Handle visited list clicks
  if (e.target.classList.contains('place-title-btn')) {
    console.log("click!");
    const placeId = e.target.dataset.placeId;
    console.log(placeId);
    openEateryModal(placeId);
  }
});

document.getElementById('close-must-try-modal').addEventListener('click', () => {
  document.getElementById('must-try-modal').classList.add('hidden');
  document.getElementById('must-try-circles').classList.add('d-none');
});

document.getElementById('back-to-profile').addEventListener('click', () => {
  loadProfile();
});



const colors = ['#FF69B4', '#FFD700', '#00FFFF', '#ADFF2F', '#FF4500', '#9370DB'];

function createCircle() {
  const circle = document.createElement('div');
  circle.classList.add('circle');
  circle.style.left = Math.random() * 100 + 'vw';
  circle.style.top = '-20px';
  circle.style.background = colors[Math.floor(Math.random() * colors.length)];
  circle.style.animationDuration = 2 + Math.random() * 8 + 's';
  circle.style.transform = `scale(${0.6 + Math.random() * 0.8})`;

  document.getElementById('must-try-circles').appendChild(circle);

  setTimeout(() => {
    circle.remove();
  }, 5000);
}

setInterval(createCircle, 150);

function setupLightbox() {
  const overlay = document.getElementById('lightbox-overlay');
  const overlayImg = document.getElementById('lightbox-img');
  const closeBtn = document.querySelector('.lightbox-close');

  document.body.addEventListener('click', (e) => {
    const img = e.target.closest('.eatery-image');
    if (!img) return;
    overlayImg.src = img.src;
    overlayImg.alt = img.alt || 'Full view';
    overlay.classList.remove('hidden');
  });

  closeBtn.addEventListener('click', () => {
    overlay.classList.add('hidden');
    overlayImg.src = '';
  });

  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) {
      overlay.classList.add('hidden');
      overlayImg.src = '';
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !overlay.classList.contains('hidden')) {
      overlay.classList.add('hidden');
      overlayImg.src = '';
    }
  });
}

function setupStatScrolling() {
  const stats = document.querySelectorAll('.stat[data-scroll-to]');
  
  stats.forEach(stat => {
    stat.style.cursor = 'pointer';
    stat.addEventListener('click', () => {
      const targetClass = stat.dataset.scrollTo;
      const targetSection = document.querySelector(`.${targetClass}`) || document.getElementById(targetClass);
      
      if (targetSection) {
        targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
}
